module.exports = __webpack_public_path__ + "static/media/tw.6df22a1f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/tw.png
// module id = 2006
// module chunks = 0